/**
 * @function Columns
 * @param {Object} data - The data object containing various configuration options for the columns.
 * @param {Array} data.modules - An array of modules, defining the structure of the components within the columns.
 * @param {String} data.desktopColumn - The number of columns for the desktop view.
 * @param {String} data.mobileColumn - The number of columns for the mobile view.
 * @returns {JSX.Element} - A React component representing the Columns section.
 * @description This component takes in data and dynamically renders various other components such as Banner, Carousels, Text, etc., based on the provided data. The number of columns for desktop and mobile views can also be defined.
 * @example
 * const data = {
 *   modules: [
 *     { _type: 'carousel', type: 'Carousel - Products', _id: '1' },
 *     { _type: 'banner', _id: '2' },
 *     // other modules...
 *   ],
 *   desktopColumn: '3',
 *   mobileColumn: '1'
 * };
 * <Columns data={data} />
 */
import Banner from '../components/banners/Banner.client';
import HeroCarousel from '../components/carousel/HeroCarousel.client';
import ProductCarousel from '../components/carousel/ProductCarousel.client';
import BlogCarousel from '../components/carousel/BlogCarousel.client';
import ExploreCollections from '../components/explore/Collections.client';
import Text from '../components/text/Text.client';
import AccordionPage from '../components/AccordionPage.client';
import ContactComponent from '../components/forms/Contact.client';
import WholesaComponent from '../components/forms/Wholesale.client';
import Newsletter from '../components/forms/Newsletter.client';
import '../assets/css/custom.css';

export default function Columns({data}) {
  let order = data?.modules
    ? data.modules.map((item) => {
        switch (item._type) {
          case 'carousel':
            if (item.type == 'Carousel - Products') {
              return <ProductCarousel sanity={item} key={item._id} />;
            }
            if (item.type == 'Carousel - Blog') {
              return <BlogCarousel sanity={item} key={item._id} />;
            }
            break;
          case 'banner':
            return (
              <Banner sanity={item} key={item._id} classWidth isColumn={true} />
            );
            break;
          case 'explore':
            return <ExploreCollections sanity={item} key={'ex'+item._id} />;
            break;
          case 'hero':
            return <HeroCarousel sanity={getSanity(item._type, item.name)} />;
            break;
          case 'title':
            return <Text sanity={item} key={item._id} />;
            break;
          case 'accordion':
            return <AccordionPage sanity={item} key={item._id} />;
            break;
          case 'forms':
            switch (item.formType) {
              case 'wholesale':
                return <WholesaComponent key={item._id} />;
                break;
              case 'contact':
                return <ContactComponent key={item._id} />;
                break;
              case 'newsletter':
                return <Newsletter key={item._id} />;
                break;
            }
            break;
          case 'columns':
            return <Columns data={item} key={item._id} />;
            break;
        }
      })
    : [];

  return (
    <>
      <section className="section_librero section_newsletter mx-auto">
        <div className="container">
          <div
            className={`grid gap-4 grid-cols-${data.desktopColumn}  xs:grid-cols-${data.mobileColumn} p-0 xs:p-0  items-stretch`}
          >
            {order ? order : ''}
          </div>
        </div>
      </section>
    </>
  );
}
